import React from "react"

import ErrorBoundary from "@/components/ErrorBoundary"

const raiseError = function (message) {
  throw new Error(message)
}

const SomeErroringComponent = (_props) => {
  ;<div>{raiseError("UI Test Error from AppWithErrorBoundary")}</div>
}

const App = (_props) => (
  <ErrorBoundary>
    <SomeErroringComponent />
  </ErrorBoundary>
)

export default App
